import { openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "mf-snackbar-host"
};
import { computed } from 'vue';
import MfSnackbar from '@/gondola/components/MfSnackbar/MfSnackbar.vue';
import { snackbarService } from '@/design/core/composables/useSnackbar';
export default {
  __name: 'Snackbar',
  setup(__props) {
    const snackbarState = snackbarService.state;
    const isVisible = computed(() => snackbarState.isVisible);
    const variant = computed(() => snackbarState.variant);
    const text = computed(() => snackbarState.text);
    const instanceKey = computed(() => snackbarState.instanceKey);
    const close = () => {
      snackbarService.close();
    };
    return (_ctx, _cache) => {
      return isVisible.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(), _createBlock(MfSnackbar, {
        key: instanceKey.value,
        variant: variant.value,
        message: text.value,
        onDismiss: close
      }, null, 8, ["variant", "message"]))])) : _createCommentVNode("", true);
    };
  }
};